import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';

import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';
import { ProductSearchMetadata } from '../product-list.mapper';
import { RouterLink } from '@angular/router';
import { AddLocalePipe } from '../../../../pipes/url-locale.pipe';

@Component({
  selector: 'app-product-list-header',
  imports: [RouterLink, AddLocalePipe],
  templateUrl: './product-list-header.component.html',
  styleUrls: ['./product-list-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductListHeaderComponent {
  private _metaData!: ProductSearchMetadata;
  private breakpointObserver = inject(BreakpointObserver);
  private readonly sanitizer = inject(DomSanitizer);

  @Input({ required: true })
  set metaData(value: ProductSearchMetadata) {
    this._metaData = value;
    this.processHeaderData();
  }

  get metaData(): ProductSearchMetadata {
    return this._metaData;
  }

  description!: SafeHtml;
  breadcrumbs!: { name: string; href: string | null }[];

  isMobile = toSignal(
    this.breakpointObserver.observe('(min-width: 64em)').pipe(
      map((v) => !v.matches),
      takeUntilDestroyed(),
    ),
  );

  private processHeaderData(): void {
    this.description = this.sanitizer.bypassSecurityTrustHtml(
      this._metaData.category.description,
    );

    this.breadcrumbs = this._metaData.category.prettyName
      .split('->')
      .map((name, index, array) => {
        const permalink = this._metaData.category.permaLink.split('/');
        const hrefValue =
          index === 0
            ? permalink[index]
            : array.length === index + 1
              ? null
              : permalink.slice(0, index + 1).join('/');

        return { name: name.trim(), href: hrefValue };
      });
  }
}
